
export default function EducatorsAboutSection() {
  return (
    <section className="w-full p-4">
      <div className="rounded-3xl bg-background px-4 p-4 text-center shadow-sm flex justify-center items-center flex-col">
        <img
          src="/svgs/logo-no-frame.svg"
          className="size-20 max-w-none"
        />

        <h2 className="mt-1 text-sm font-extrabold leading-6 text-foreground">
          آموزیم چیست؟
        </h2>

        <p className="mt-3 text-sm leading-7 text-default-700">
          آموزیم بستری برای انتشار و ارائه دوره‌های آموزشی در ایتاست؛ پلتفرمی
          که با هدف ساده‌تر کردن مسیر یادگیری و آموزش طراحی شده.
        </p>

        <p className="mt-5 text-sm leading-7 text-default-700">
          در آموزیم شما می‌توانید به آموزش‌های مختلف دسترسی داشته باشید و با
          یادگیری مهارت‌های جدید پیشرفت کنید و اگر مدرس یا معلم هستین، آموزش‌ها
          و دوره‌های خودتون رو منتشر کنین و در اختیار دیگران قرار بدین.
        </p>
      </div>
    </section>
  );
}

